module.exports = __webpack_public_path__ + "img/drawing.545a5bdd.svg";